export const assignmentTypes = {
  automatic: 'random',
  manual: 'manual'
};
